const AUTH_TOKEN_KEY = 'AUTH_TOKEN';

export default class TokenStore {

    constructor(storage) {
        this.storage = storage || localStorage;
        if (!this.storage) {
            throw new Error('TokenStore: storage (or localStorage) is required');
        }
    }

    getToken() {
        return storage.getItem(AUTH_TOKEN_KEY);
    }

    setToken(newToken) {
        storage.setItem(AUTH_TOKEN_KEY, newToken);
    }

    clearToken(newToken) {
        storage.removeItem(AUTH_TOKEN_KEY);
    }
}



// WEBPACK FOOTER //
// ./src/DashAuthenticatedUser/TokenStore.js


// WEBPACK FOOTER //
// webpack:///src/DashAuthenticatedUser/TokenStore.js